import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import DatePicker from "../../components/DatePicker";
import { Loader2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { localStrings } from "../../i18n/homeStrings";

export function MeetingDialog({
  open, onOpenChange,
  meetingTitle, setMeetingTitle,
  meetingDate, setMeetingDate,
  meetingStartTime, setMeetingStartTime,
  meetingEndTime, setMeetingEndTime,
  savingMeeting, handleCreateMeeting, t,
}) {
  const { language } = useLanguage();
  const s = localStrings(language);

  // Times are "HH:MM", so comparing the strings compares the times.
  const timesOutOfOrder = Boolean(
    meetingStartTime && meetingEndTime && meetingEndTime < meetingStartTime
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">{t("meeting.schedule")}</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleCreateMeeting} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="meetingTitle">{t("meeting.title")}</Label>
            <Input id="meetingTitle" data-testid="meeting-title-input" value={meetingTitle} onChange={(e) => setMeetingTitle(e.target.value)} placeholder={t("meeting.titlePlaceholder")} required className="border-slate-200" />
          </div>
          <div className="space-y-2">
            <Label>{t("meeting.date")}</Label>
            {/* The application's own picker rather than the browser's, which
                looks different in every browser and, on a desktop, gives no
                way to reach a month far off without clicking through each one.
                Same control as the decay calculator and the audit log. */}
            <DatePicker
              testId="meeting-date-input"
              value={meetingDate}
              onChange={setMeetingDate}
              placeholder={s("date.choose")}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label htmlFor="meetingStartTime">{t("meeting.startTime")}</Label>
              <Input id="meetingStartTime" data-testid="meeting-start-time-input" type="time" value={meetingStartTime} onChange={(e) => setMeetingStartTime(e.target.value)} required className="border-slate-200" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="meetingEndTime">{t("meeting.endTime")}</Label>
              <Input id="meetingEndTime" data-testid="meeting-end-time-input" type="time" value={meetingEndTime} onChange={(e) => setMeetingEndTime(e.target.value)} required className="border-slate-200" />
            </div>
          </div>
          {timesOutOfOrder && (
            <p className="text-xs text-red-600" data-testid="meeting-time-order-error">
              {t("meeting.timeOrder")}
            </p>
          )}
          <div className="flex flex-wrap justify-end gap-3 pt-4">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-slate-200">{t("meeting.cancel")}</Button>
            <Button type="submit" data-testid="create-meeting-btn" disabled={savingMeeting || !meetingDate || timesOutOfOrder} className="bg-indigo-700 hover:bg-indigo-600 text-white">
              {savingMeeting ? <Loader2 className="w-4 h-4 animate-spin" /> : t("meeting.create")}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
